export function windowInFrame(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('embed') === '1') return true;
    return window.self !== window.top;
  } catch {
    return true;
  }
}
